
import state from './moduleMasterFieldsManagementState'
import mutations from './moduleMasterFieldsManagementMutations'
import actions from './moduleMasterFieldsManagementActions'
import getters from './moduleMasterFieldsManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

